import { render, staticRenderFns } from "./GFSettlementDocumentsFront.vue?vue&type=template&id=8341d1a2"
import script from "./GFSettlementDocumentsFront.vue?vue&type=script&lang=js"
export * from "./GFSettlementDocumentsFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports